var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('disqualifier',{attrs:{"orderStatus":1}}),_c('vxe-loading',{model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }